import { GoArrowSwitch } from 'react-icons/go'
import { PiMoneyWavy } from 'react-icons/pi'
import { SiMicrosoftexcel } from 'react-icons/si'
import { Spinner } from '@nextui-org/react'
import { useEffect, useState } from 'react'
import { webApiService } from '../DashboardIndex'
import { formatCurrency } from '../utils'
import { useDashboard } from '../context/DashboardContext'
import { SELLERS_BOOST_LIST } from '../constants'
import * as XLSX from 'xlsx'

export default function Cards () {
  const { country, dateRange, selectedSeller, selectedRegion, selectedStore, incrementLoadingCards, decrementLoadingCards } = useDashboard()
  const [loading, setLoading] = useState<boolean>(true)
  const [downloading, setDownloading] = useState<boolean>(false)
  const [value, setValue] = useState<{total: number, amount: number, inWarehouse: number}>({ total: 0, amount: 0, inWarehouse: 0 })

  const handleDownload = async () => {
    setDownloading(true)
    try {
      let download
      if (country === 'MX' && selectedSeller && SELLERS_BOOST_LIST.includes(selectedSeller)) {
        download = await webApiService.downloadDeliveredBoost({ start: String(dateRange.start), end: String(dateRange.end), idSeller: selectedSeller, region: selectedRegion || null, store: selectedStore || null }).then(res => res.data)
      } else {
        download = await webApiService.downloadDelivered({ start: String(dateRange.start), end: String(dateRange.end), idSeller: selectedSeller, region: selectedRegion || null, store: selectedStore || null }).then(res => res.data)
      }

      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(download.details), 'Detalle')
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(download.resume), 'Resumen')
      XLSX.writeFile(wb, 'tradein_entregados.xlsx')
    } catch (error) {
      console.error('Error al descargar el archivo Excel:', error)
    } finally {
      setDownloading(false)
    }
  }

  useEffect(() => {
    let cancelled = false

    const loadData = async () => {
      setLoading(true)
      incrementLoadingCards()

      const response = await webApiService.getDelivered({ start: String(dateRange.start), end: String(dateRange.end), idSeller: selectedSeller, region: selectedRegion || null, store: selectedStore || null }).then(res => res.data)

      if (!cancelled) {
        setValue(response)
        setLoading(false)
      }
      decrementLoadingCards()
    }

    loadData()

    return () => {
      cancelled = true
    }
  }, [dateRange, selectedRegion, selectedStore]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>

      <div className='bg-white rounded-2xl shadow-sm border border-gray-100 p-6'>
        <div className='flex items-center justify-between mb-4'>
          <div className='flex items-center gap-2 text-[#8492a6] text-sm font-semibold'>
            <GoArrowSwitch size={18} />
            Retomas Totales
          </div>
          {downloading
            ? <Spinner size='sm' color='primary' />
            : <SiMicrosoftexcel size={18} className='text-[#8492a6] cursor-pointer hover:text-green-600 transition-colors' onClick={handleDownload} />}
        </div>
        {loading
          ? <Spinner size='lg' color='primary' />
          : value.total === 0
            ? <span className='text-sm text-[#8492a6]'>Sin datos disponibles</span>
            : <span className='text-4xl font-bold text-[#1a202c]'>{value.total}</span>}
      </div>

      <div className='bg-white rounded-2xl shadow-sm border border-gray-100 p-6'>
        <div className='flex items-center justify-between mb-4'>
          <div className='flex items-center gap-2 text-[#8492a6] text-sm font-semibold'>
            <PiMoneyWavy size={18} />
            Monto total
          </div>
        </div>
        {loading
          ? <Spinner size='lg' color='primary' />
          : value.amount === 0
            ? <span className='text-sm text-[#8492a6]'>Sin datos disponibles</span>
            : (
              <span className='text-4xl font-bold text-[#1a202c]'>
                {country === 'CL' ? 'CLP ' : country === 'MX' ? 'MXN ' : 'PEN '}
                {formatCurrency(value.amount, country)}
              </span>
              )}
      </div>

    </div>
  )
}
